












































import _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { TYPES, STATUSES } from '@/constants/booking';
import BookingReadServiceOrderPaymentMethods from './BookingReadServiceOrderPaymentMethods.vue';

@Component({
  components: {
    BookingReadServiceOrderPaymentMethods,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
      serviceItemTotalAvailableQuantity: 'serviceItemTotalAvailableQuantity',
    }),
    ...mapGetters('ServiceItem', {
      assessmentAvailable: 'assessmentAvailable',
    }),
  },
})
export default class BookingReadPayment extends Vue {
  booking!: Model;
  business!: Model;

  serviceItems!: Model[];
  assessmentAvailable!: number;

  types = TYPES;
  statuses = STATUSES;

  serviceItemTotalAvailableQuantity!: [];

  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchServiceItemTotalAvailableQuantityFinished: false,
    isApiFetchRiskProfileFinished: false,
  };

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }

      // When all APIs call finished, calculate current business available questack quantity,
      // and how many questack against to the SI will be consumed.
      for (const item of this.serviceItems) {
        if (item.object_id) {
          // assign avaialble quantity to SI.current_quantity
          item.current_quantity = _.get(
            this.serviceItemTotalAvailableQuantity,
            item.object_id,
            0
          );

          if (
            item.key == 'assessment' &&
            this.assessmentAvailable < this.booking.candidate_number
          ) {
            // calculate the required questacks (if business don't have enough questack)
            item.required_quantity =
              Number(this.booking.candidate_number) -
              Number(this.assessmentAvailable);
          } else {
            // other SI, no need to set required_quantity
            item.required_quantity = 0;
          }
        }
      }

      this.$emit('fetched', this.serviceItems);
    }
  }

  get isAwaitPayment() {
    return this.booking.status == this.statuses.STATUS_AWAIT_PAYMENT.key;
  }

  init() {
    this.isApiFetch = {
      isApiFetchServiceItemsFinished: false,
      isApiFetchServiceItemTotalAvailableQuantityFinished: false,
      isApiFetchRiskProfileFinished: false,
    };

    this.$store
      .dispatch(
        'RiskProfile/fetchFullStructure',
        this.booking.risk_profile.object_id
      )
      .then(() => {
        this.isApiFetch['isApiFetchRiskProfileFinished'] = true;
      });

    this.$store.dispatch('ServiceItem/fetchList').then(() => {
      this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
    });

    this.$store
      .dispatch(
        'ServiceItem/serviceItemTotalAvailableQuantity',
        this.business.object_id
      )
      .then(() => {
        this.isApiFetch[
          'isApiFetchServiceItemTotalAvailableQuantityFinished'
        ] = true;
      });
  }

  beforeMount() {
    this.init();
  }

  consume() {
    this.$emit('consume');
  }

  openDialog() {
    this.$store.commit('OPEN_DIALOG', {
      open: true,
      content: 'ServiceOrderCreate',
      serviceItems: this.serviceItems,
      fullscreen: true,
      floater: true,
    });
  }

  // handleConsume({payment, result}) {
  //   console.debug(payment)
  //   console.debug(result)
  //   if (result.error) {
  //     this.$router.push({
  //       name: "business-payment-read",
  //       params: {
  //         paymentOid: payment.object_id
  //       }
  //     })
  //   } else {
  //     this.showPaymentCreate = false
  //     this.$emit("handle-consume", payment)
  //   }
  // }

  // afterPrepaidSubmitted() {
  //   this.showServiceOrderRead = true
  //   // this.showServiceOrderCreate = false
  // }

  get additionalServices() {
    return this.serviceItems
      .filter((serviceItem) => serviceItem.key !== 'assessment')
      .map((serviceItem) => {
        return {
          object_id: serviceItem.object_id,
          key: serviceItem.key,
          name: serviceItem.name,
        };
      });
  }

  calculateServiceQuantityBy(objectId) {
    return this.booking.booking_candidates?.filter(
      (candidate) =>
        candidate.service_candidates.filter(
          (serviceCandidate) =>
            serviceCandidate.service_item.object_id === objectId
        ).length
    ).length;
  }
}
